<template>
    <div class="map-view-container">
        <el-container class="main-container">
            <el-aside width="380px" class="map-sidebar">
                <div class="sidebar-header">
                    <h3>Peta Data</h3>
                    <p>Visualisasi data infrastruktur Kota Bandung</p>
                </div>

                <el-tabs v-model="activeTab" class="sidebar-tabs">
                    <el-tab-pane label="Filter" name="filter">
                        <el-form :model="filter" class="filter-form">
                            <el-form-item>
                                <el-select 
                                    placeholder="Pilih aktivitas" 
                                    v-model="filter.flow" 
                                    clearable 
                                    filterable 
                                    multiple
                                    :multiple-limit="3"
                                    style="width: 100%"
                                >
                                    <el-option 
                                        v-for="(item, index) in listFlows" 
                                        :key="index"
                                        :label="item.group_name + ' - ' + item.flow_name" 
                                        :value="item.id" 
                                    />
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item>
                                <el-input 
                                    v-model="filter.q" 
                                    placeholder="Cari data..." 
                                    clearable
                                    :prefix-icon="Search"
                                />
                            </el-form-item>
                            
                            <el-form-item>
                                <el-select 
                                    v-model="filter.kecamatan" 
                                    clearable 
                                    filterable 
                                    multiple 
                                    :multiple-limit="3"
                                    placeholder="Pilih kecamatan"
                                    style="width: 100%"
                                >
                                    <el-option 
                                        v-for="(item, index) in kecamatan" 
                                        :key="index" 
                                        :label="index"
                                        :value="index" 
                                    />
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item>
                                <el-select 
                                    placeholder="Pilih UPTD" 
                                    v-model="filter.uptd" 
                                    clearable 
                                    filterable 
                                    multiple
                                    :multiple-limit="3"
                                    style="width: 100%"
                                >
                                    <el-option 
                                        v-for="(item, index) in LOVData.uptd" 
                                        :key="index"
                                        :label="item.lov_label" 
                                        :value="item.lov_value" 
                                    />
                                </el-select>
                            </el-form-item>
                            
                            <el-form-item>
                                <el-date-picker
                                    v-model="filter.dateRange"
                                    type="daterange"
                                    range-separator="s/d"
                                    start-placeholder="Tanggal mulai"
                                    end-placeholder="Tanggal akhir"
                                    format="DD-MM-YYYY"
                                    value-format="YYYY-MM-DD"
                                    style="width: 100%"
                                    :shortcuts="dateShortcuts"
                                />
                            </el-form-item>
                            
                            <el-form-item>
                                <el-button 
                                    type="primary" 
                                    @click="filterData"
                                    :icon="Search"
                                    :loading="isLoading"
                                    style="width: 100%"
                                >
                                    Cari Data
                                </el-button>
                            </el-form-item>
                            
                            <el-alert 
                                v-if="filter.invalid_message" 
                                :title="filter.invalid_message" 
                                type="warning" 
                                :closable="false"
                                style="margin-bottom: 15px;"
                            />
                            
                            <div v-show="kondisiJalanSelected" class="road-options">
                                <el-divider content-position="left">Opsi Tampilan Jalan</el-divider>
                                <el-checkbox 
                                    v-model="showRuasJalan" 
                                    @change="toogleRuasJalan" 
                                    label="Tampilkan Nama Ruas Jalan" 
                                />
                                <el-checkbox 
                                    v-model="showFungsiJalan" 
                                    @change="toogleTypeJalan"  
                                    label="Tampilkan Berdasarkan Fungsi Jalan" 
                                />
                            </div>
                            
                        </el-form>
                    </el-tab-pane>
                    <el-tab-pane label="Rekap" name="rekap">
                            <div v-if="selectedFlow.length > 0" class="summary-section">
                                <div v-for="(item, index) in selectedFlow" :key="index" class="summary-item">
                                    <div class="summary-header">
                                        <img height="20" :src="markerColors[index]" style="margin-right: 8px;"> 
                                        <span style="font-weight: 600;">{{ item.group_name + ' - ' + item.flow_name }}</span>
                                    </div>
                                    <el-descriptions size="small" direction="vertical" :column="1" border class="summary-descriptions">
                                        <el-descriptions-item v-if="mainData[item.table_name]" label="Jumlah Data">
                                            {{ mainData[item.table_name].length }}
                                        </el-descriptions-item>
                                        <span v-if="sum_value[item.table_name] && sum_value[item.table_name].sum">
                                            <el-descriptions-item 
                                                v-for="(rec, key) in sum_value[item.table_name].sum"
                                                :key="key" 
                                                :label="displayField(item.table_name, key)"
                                            >
                                                {{ formatNumber(rec) }}
                                            </el-descriptions-item>
                                        </span>
                                    </el-descriptions>
                                </div>
                            </div>
                    </el-tab-pane>
                    <el-tab-pane 
                        v-for="(item, indexTab) in selectedFlow" 
                        :label="item.flow_name" 
                        :name="item.flow_name"
                        :key="indexTab"
                    >
                        <el-table 
                            @row-click="selectRecord($event, item.id)" 
                            :data="mainData[item.table_name]" 
                            :stripe="true"
                            empty-text="Tidak ada data"
                            style="width: 100%; cursor: pointer;"
                            :height="tableHeight"
                        >
                            <el-table-column>
                                <template #default="scope">
                                    <div class="table-row-content">
                                        <div class="icon-column">
                                            <el-icon v-if="scope.row.coordinate" color="#409EFF">
                                                <Location />
                                            </el-icon>
                                        </div>
                                        <div class="data-content">
                                            <div v-for="(field, index) in item.fields" :key="index">
                                                <span v-if="scope.row[field]" :class="{ 'primary-text': index === 0, 'secondary-text': index > 0 }">
                                                    {{ scope.row[field] }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-aside>
            
            <el-main class="map-container">
                <div ref="mapContainer" style="width: 100%; height: 100%;"></div>
            </el-main>
        </el-container>

        <el-drawer 
            v-model="drawerDetailInformasi" 
            direction="rtl"
            :size="400"
            :destroy-on-close="true"
        >
            <template #header>
                <h3 style="margin: 0;">Detail {{ detailFlowSelected.flow_name }}</h3>
            </template>

            <el-descriptions 
                size="small" 
                direction="vertical"
                :column="1" 
                border
                class="detail-descriptions"
            >
                <span v-for="(field, index) in listFields" :key="index">
                    <el-descriptions-item
                        v-if="field.show == 'Yes' && field.field_type == 'image' && detailData[field.field_name]"
                        :label="field.field_title">
                        <img width="200px" alt="" :src="detailData[field.field_name]" />
                    </el-descriptions-item>

                    <el-descriptions-item
                        v-else-if="field.show == 'Yes' && field.field_type == 'url' && detailData[field.field_name]"
                        :label="field.field_title">
                        <a :href="detailData[field.field_name]" target="_blank"> {{ detailData[field.field_name] }} </a>
                    </el-descriptions-item>

                    <el-descriptions-item
                        v-else-if="field.show == 'Yes' && field.field_type == 'file' && detailData[field.field_name]"
                        :label="field.field_title">
                        <a :href="detailData[field.field_name]" target="_blank"> {{ detailData[field.field_name] }} </a>
                    </el-descriptions-item>

                    <el-descriptions-item
                        v-else-if="field.show == 'Yes' && field.field_type == 'coordinate' && detailData[field.field_name]"
                        :label="field.field_title">
                        <span> {{ detailData[field.field_name] }} </span>
                    </el-descriptions-item>

                    <el-descriptions-item
                        v-else-if="field.show == 'Yes' && field.field_type == 'paragraph' && detailData[field.field_name]"
                        :label="field.field_title">
                        <span v-if="field.field_name != 'coordinates'"> {{ detailData[field.field_name] }} </span>
                    </el-descriptions-item>

                    <el-descriptions-item
                        v-else-if="field.show == 'Yes' && field.field_type == 'number' && detailData[field.field_name]"
                        :label="field.field_title">
                        <span v-if="detailData[field.field_name]"> {{ detailData[field.field_name].toLocaleString() }} </span>
                    </el-descriptions-item>

                    <el-descriptions-item v-else-if="field.show == 'Yes' && detailData[field.field_name]"
                        :label="field.field_title">
                        <span> {{ detailData[field.field_name] }} </span>
                    </el-descriptions-item>
                </span>

                <el-descriptions-item label="Dibuat Oleh">
                    <span v-if="detailData['created_at']">{{ formatDateTime(detailData['created_at']) }}, </span>
                    <span>{{ detailData['created_by'] }}</span>
                </el-descriptions-item>
            </el-descriptions>
            
            <el-divider content-position="left">Catatan</el-divider>
            <el-descriptions size="small" direction="vertical" :column="1" border class="notes-descriptions">
                <el-descriptions-item v-for="(itemNote, index) in detailCatatan" :key="index"
                    :label="itemNote.created_at.substr(0, 16) + ', ' + itemNote.created_by">
                    <div>
                        <p>
                            {{ itemNote.note }} <br>
                            <b v-if="itemNote.categories"> {{ itemNote.categories }} <br> </b>
                            <b v-if="itemNote.coordinate">
                                <a :href="'https://www.google.com/maps?q=' + itemNote.coordinate" target="_blank"> {{
                                    itemNote.coordinate }} </a> <br> </b>
                            <br>
                            <img v-if="itemNote.file_url" width="200px" alt=""
                                :src="'https://apidev.putrabandung.com/api/files/view/' + itemNote.file_url" />
                        </p>
                    </div>
                </el-descriptions-item>
            </el-descriptions>

        </el-drawer>
    </div>
</template>

<script>
import axios from 'axios'
import { Search, Location } from '@element-plus/icons-vue'

export default {
    name: "MapView",
    data() {
        return {
            Search,
            Location,
            mainData: {},
            totalMainData: {},
            filteredMainData: { rec_pbg: [], rec_jj_kondisi_jalan: [] },
            listFlows: [],
            listFields: [],
            filter: { kecamatan: [], uptd: [], flow: [], q: "", invalid_message: "", dateRange: null },
            showRuasJalan: false,
            showFungsiJalan: false,
            defPagination: { count: 0, total_count: 0, page: 1, total_page: 1, page_size: 10 },
            mainPagination: {},
            tableChildData: [],
            detailFlowSelected: {},
            fields: [],
            detailData: {},
            detailCatatan: [],
            LOVData: { uptd: [] },
            map: null,
            drawerDetailInformasi: false,
            defaultCenter: { lat: -6.9301758, lng: 107.6375198 }, // pu bandung
            defaultZoom: 10,
            filtered_ruas_jalan: [],
            filtered_detail_ruas_jalan: [],
            no_ruas_jalan: [],
            wilayah: [],
            selectedWilayah: [],
            ringkasanJalan: {
                panjang_ruas_km: 0,
                kondisi_baik_km: 0,
                kondisi_sedang_km: 0,
                kondisi_rusak_ringan_km: 0,
                kondisi_rusak_berat_km: 0
            },
            kecamatan: {
                "Arjasari": "#FF6B6B",        // Merah cerah
                "Baleendah": "#FFD93D",       // Kuning terang
                "Banjaran": "#6BCB77",        // Hijau segar
                "Bojongsoang": "#4D96FF",     // Biru terang
                "Cicalengka": "#FF6FF2",      // Pink neon
                "Cikancung": "#FF922B",       // Oranye terang
                "Cileunyi": "#845EC2",        // Ungu cerah
                "Cilengkrang": "#00C9A7",     // Biru kehijauan terang
                "Cimaung": "#FFC75F",         // Kuning-oranye cerah
                "Ciparay": "#C34A36",         // Merah bata cerah
                "Ciwidey": "#59C3C3",         // Cyan pastel cerah
                "DayeuhKolot": "#F9F871",     // Kuning neon
                "Ibun": "#0081CF",            // Biru tajam
                "Katapang": "#B8DE6F",        // Hijau lemon
                "Kertasari": "#F25F5C",       // Coral
                "Kutawaringin": "#9D4EDD",    // Ungu muda mencolok
                "Majalaya": "#FFABAB",        // Pink pucat terang
                "Margaasih": "#20A39E",       // Tosca cerah
                "Margahayu": "#EF476F",       // Pink-merah cerah
                "Nagreg": "#06D6A0",          // Teal neon
                "Pacet": "#FFD166",           // Kuning pastel
                "Pameungpeuk": "#118AB2",     // Biru laut
                "Pangalengan": "#4895EF",         // Biru murni cerah
                "Pasirjambu": "#F9844A",      // Oranye lembut cerah
                "Paseh": "#43AA8B",           // Hijau daun
                "Rancaekek": "#577590",       // Biru abu muda
                "Rancabali": "#F72585",       // Pink tajam
                "Solokanjeruk": "#3A0CA3",    // Ungu biru gelap terang
                "Soreang": "#E63946",     // Merah cerah klasik
                "Cangkuang": "#80FF72",       // Hijau neon
                "Cimenyan": "#FF5DA2"         // Pink salmon cerah
            },
            rencana_pola_ruang_colors:{
                "Badan Air": "#97dbf2",
                "Badan Jalan": "#eb1e1e",
                "Hutan Produksi Tetap": "#69b437",
                "Jalur Hijau": "#0ff500",
                "Kawasan Peruntukan Industri": "#690000",
                "Pariwisata": "#ffa5ff",
                "Pemakaman": "#5aff00",
                "Pembangkitan Tenaga Listrik": "#00ffcd",
                "Perdagangan dan Jasa Skala Kota": "#ff6464",
                "Perdagangan dan Jasa Skala SWP": "#ffa5a5",
                "Perdagangan dan Jasa Skala WP": "#ff8282",
                "Pergudangan": "#373737",
                "Perkantoran": "#9b9b9b",
                "Perkebunan": "#afaf37",
                "Perlindungan Setempat": "#05d7d7",
                "Pertahanan dan Keamanan": "#9b00ff",
                "Perumahan Kepadatan Rendah": "#fffa4b",
                "Perumahan Kepadatan Sedang": "#fff005",
                "Perumahan Kepadatan Tinggi": "#ffdc00",
                "Peruntukan Pertambangan Batuan": "#5f7391",
                "Peternakan": "#b9ebb9",
                "Ruang Terbuka Non Hijau": "#006969",
                "SPU Skala Kecamatan": "#9b329b",
                "SPU Skala Kelurahan": "#b94bb9",
                "SPU Skala Kota": "#7d197d",
                "Taman Kecamatan": "#468700",
                "Taman Kelurahan": "#4ba500",
                "Taman Kota": "#416900",
                "Taman RT": "#55e100",
                "Taman RW": "#50c300",
                "Tanaman Pangan": "#c8f546",
                "Transportasi": "#d73700"
            },
            pola_ruang_line : ["Badan Jalan","Badan Air"],
            markerColors: [
                'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
                'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
                'https://maps.google.com/mapfiles/ms/icons/blue-dot.png',
            ],
            activeTab: "filter",
            dateShortcuts: [
                {
                    text: 'Minggu ini',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        return [start, end]
                    }
                },
                {
                    text: 'Bulan ini',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setDate(1)
                        return [start, end]
                    }
                },
                {
                    text: '3 bulan terakhir',
                    value: () => {
                        const end = new Date()
                        const start = new Date()
                        start.setMonth(start.getMonth() - 3)
                        return [start, end]
                    }
                }
            ],
            sum_fields: {
                rec_pbg: {
                    count: ["kecamatan", "fungsi_bg"],
                    sum: ["usulan_retribusi", "nilai_retribusi_keseluruhan_simbg", "nilai_retribusi_keseluruhan_pad", "denda"],
                    labels: {
                        "usulan_retribusi": "Total Usulan Retribusi",
                        "nilai_retribusi_keseluruhan_simbg": "Total Retribusi",
                        "nilai_retribusi_keseluruhan_pad": "Total Retribusi PAD",
                        "denda": "Total Denda"
                    },
                },
                rec_bg_temuan: {
                    count: ["kecamatan", "jenis_bg_temuan"],
                    sum: ["perkiraan_luas"],
                    labels: {
                        "kecamatan": "Jumlah per Kecamatan",
                        "jenis_bg_temuan": "Jumlah per Jenis Temuan",
                        "perkiraan_luas": "Total Perkiraan Luas",
                    },
                },
                rec_jj_kondisi_jalan: {
                    count: ["kecamatan","desa"],
                    sum: ["kondisi_baik_km","kondisi_sedang_km","kondisi_rusak_ringan_km","kondisi_rusak_berat_km"],
                    labels: {
                        "kondisi_baik_km": "Kondisi Baik (KM)",
                        "kondisi_sedang_km": "Kondisi Sedang (KM)",
                        "kondisi_rusak_ringan_km": "Kondisi Rusak Ringan (KM)",
                        "kondisi_rusak_berat_km": "Kondisi Rusak Berat (KM)",
                        "kecamatan": "kecamatan",
                        "desa": "desa"
                    },
                },
            },
            sum_value: {},
            isLoading: false
        }
    },
    created() {
        this.mapWilayah = []
        this.mapJalan = []
        this.mapDrainase = []
        this.mapBG = []
        this.mapPolaRuangArea = []
        this.mapPolaRuangLine = []
        this.mapDataMarker = []
        this.mapLabelJalanMarker = []
        this.infoWindow = new window.google.maps.InfoWindow();

        this.getProfile()
        this.fetchWilayah()
        this.fetchLOVData({ lov_id: 'uptd' })
        //this.fetchData({ table_name: "rec_jj_kondisi_jalan", main_fields: "no_ruas,nama_ruas_jalan,kecamatan,panjang_ruas_km,lebar_ruas_m,kondisi_baik_km,kondisi_sedang_km,kondisi_rusak_ringan_km,kondisi_rusak_berat_km" })
        //this.fetchData({ table_name: "rec_pbg", main_fields: "nama_pemilik,lokasi_bg,kecamatan,no_registrasi,coordinate,longitude,latitude,tgl_permohonan" })
        //this.fetchChildData({ table_name: 'rec_jj_kondisi_jalan_child' })
    },
    mounted() {
        if (!window.google) {
            console.error('Google Maps JavaScript API is not loaded.');
            return;
        }

        // Inisialisasi peta
        this.map = new window.google.maps.Map(this.$refs.mapContainer, {
            center: this.defaultCenter,
            zoom: this.defaultZoom,
            styles: [
                {
                    featureType: "poi", //all
                    elementType: "labels",
                    stylers: [{ visibility: "off" }],
                },
            ]
        });

        const resetZoomDiv = document.createElement("div");
        resetZoomDiv.style.margin = "10px";

        const resetButton = document.createElement("button");
        resetButton.textContent = "Reset Zoom";
        resetButton.style.backgroundColor = "#fff";
        resetButton.style.border = "2px solid #ccc";
        resetButton.style.padding = "5px 10px";
        resetButton.style.cursor = "pointer";
        resetButton.style.borderRadius = "4px";

        resetZoomDiv.appendChild(resetButton);

        // Tambahkan tombol ke pojok kanan atas
        this.map.controls[window.google.maps.ControlPosition.BOTTOM_RIGHT].push(resetZoomDiv);

        // Event klik tombol
        resetButton.addEventListener("click", () => {
            this.map.setZoom(this.defaultZoom);
            this.map.setCenter(this.defaultCenter);
            /*this.mapJalan.forEach(obj => obj.setMap(null));
            this.mapJalan.splice(0)
            this.mapWilayah.forEach(obj => obj.setMap(null));
            this.mapWilayah.splice(0)
            */
        });

        /*
        const controlDiv = document.createElement('div');
        controlDiv.style.backgroundColor = '#fff';
        controlDiv.style.border = '2px solid #ccc';
        controlDiv.style.padding = '5px';
        controlDiv.style.borderRadius = '4px';
        controlDiv.style.fontFamily = 'Arial';
        controlDiv.style.margin = '13px';
        controlDiv.style.fontSize = '13px';

        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.id = 'jalanku-toggle';

        const label = document.createElement('label');
        label.htmlFor = 'jalanku-toggle';
        label.innerText = 'Nama Ruas Jalan';

        controlDiv.appendChild(checkbox);
        controlDiv.appendChild(label);

        // Push ke pojok kiri atas
        this.map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(controlDiv);

        // Event handler checkbox
        checkbox.addEventListener('change', (e) => {
            const show = e.target.checked;
            this.mapLabelJalanMarker.forEach(marker => marker.setVisible(show));
        });
        */

    },
    computed: {
        apiHeaders() {
            return {
                'Authorization': `Bearer ${this.$store.state.auth_token}`
            }
        },
        baseUrl() {
            return this.$store.state.base_url
        },
        selectedFlow() {
            const selected = this.listFlows.filter(item => {
                return this.filter.flow.indexOf(item.id) != -1
            })
            return selected
        },
        kondisiJalanSelected() {
            var selected = false
            this.filter.flow.forEach(item => {
                if(item==35){
                    selected = true
                }
            })
            return selected
        },
        tableHeight() {
            // Calculate table height based on viewport height
            // Subtract top menu (60px) and other elements (350px)
            return window.innerHeight - 300
        }
    },
    methods: {
        filterData() {
            this.isLoading = true

            this.filter.invalid_message = ""
            if (this.filter.flow.length == 0) {
                this.filter.invalid_message = "Silahkan Pilih Activity terlebih dahulu."
                this.isLoading = false
                return;
            }

            if (this.filter.flow.length > 1 && this.filter.kecamatan.length == 0 && this.filter.uptd.length == 0) {
                this.filter.invalid_message = "Silahkan Pilih Kecamatan atau UPTD terlebih dahulu."
                this.isLoading = false
                return;
            }

            this.mapDataMarker.forEach(marker => marker.setMap(null)); // hapus dari peta
            this.mapDataMarker = [];

            this.mapLabelJalanMarker.forEach(marker => marker.setMap(null)); // hapus dari peta
            this.mapLabelJalanMarker = [];

            if (this.filter.kecamatan.length > 0) {
                this.selectedWilayah = this.wilayah.filter(item => {
                    return this.filter.kecamatan.indexOf(item.kecamatan) != -1
                });
            } else {
                this.selectedWilayah = this.wilayah
            }
           this.drawWilayah()

            this.mapJalan.forEach(obj => obj.setMap(null));
            this.mapJalan.splice(0)

            this.mapDrainase.forEach(obj => obj.setMap(null));
            this.mapDrainase.splice(0)
            
            this.mapPolaRuangArea.forEach(obj => obj.setMap(null));
            this.mapPolaRuangArea.splice(0)
            
            this.mapPolaRuangLine.forEach(obj => obj.setMap(null));
            this.mapPolaRuangLine.splice(0)

            // Track async operations
            let pendingRequests = 0
            
            this.selectedFlow.forEach((flow, index) => {
                this.mainPagination[flow.table_name] = this.defPagination
                var params_rec_data = {
                    selectedFlowIndex: index,
                    table_name: flow.table_name,
                    main_fields: flow.main_fields + ',coordinate',
                    q: this.filter.q
                }
                if (this.filter.kecamatan.length > 0) {
                    params_rec_data.kecamatan = this.filter.kecamatan.join(',')
                }
                if (this.filter.uptd.length > 0) {
                    params_rec_data.uptd = this.filter.uptd.join(',')
                }
                if (this.sum_fields[flow.table_name]) {
                    params_rec_data.main_fields += ',' + this.sum_fields[flow.table_name].sum.join(',')
                }
                
                pendingRequests++
                this.fetchData(params_rec_data).finally(() => {
                    pendingRequests--
                    if (pendingRequests === 0) {
                        this.isLoading = false
                    }
                })

                if (flow.id == 35) { //kondisi jalan child
                    var params_rec_child = {
                        selectedFlowIndex: index,
                        table_name: 'rec_jj_kondisi_jalan_child',
                        //main_fields: flow.main_fields + ',coordinate',
                        q: this.filter.q
                    }
                    if (this.filter.kecamatan.length > 0) {
                        params_rec_child.kecamatan = this.filter.kecamatan.join(',')
                    }
                    if (this.filter.uptd.length > 0) {
                        params_rec_child.uptd = this.filter.uptd.join(',')
                    }
                    
                    pendingRequests++
                    this.fetchChildData(params_rec_child).finally(() => {
                        pendingRequests--
                        if (pendingRequests === 0) {
                            this.isLoading = false
                        }
                    })
                }
            });


        },
        async getProfile() {
            try {
                const response = await axios.get(`${this.baseUrl}/api/user/${localStorage.usereid}`, {
                    headers: this.apiHeaders
                })
                
                this.listFlows = response.data.access_flows
                this.listFlows.forEach(item => {
                    item.fields = item.main_fields.split(",")
                })
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data profil')
            }
        },
        async fetchLOVData(payload) {
            try {
                const params = {
                    lov_id: payload.lov_id
                }
                const response = await axios.get(`${this.baseUrl}/api/lov`, {
                    params,
                    headers: this.apiHeaders
                })
                
                this.LOVData[payload.lov_id] = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data LOV')
            }
        },
        selectJalan(row) {
            this.fetchDetailData({ flow_id: 35, rec_id: row.id })
        },
        selectBG(row) {
            this.fetchDetailData({ flow_id: 10, rec_id: row.id })
        },
        selectRecord(row, flow_id) {
            this.fetchDetailData({ flow_id: flow_id, rec_id: row.id })
        },
        getSpesificJalan(no_ruas){
            var ruas = {}
            this.mainData['rec_jj_kondisi_jalan'].map(rec => {
                if(rec.no_ruas==no_ruas){
                    ruas = rec
                }
            })
            return ruas;
        },
        toogleRuasJalan(e){
            this.mapLabelJalanMarker.forEach(marker => marker.setVisible(e));
        },
        toogleTypeJalan(e){
            console.log(e)
            this.mapJalan.forEach(obj => obj.setMap(null));
            this.mapJalan.splice(0)
            this.drawJalan()
        },
        resetViewMap() {

        },
        formatNumber(value) {
            return new Intl.NumberFormat('id-ID').format(value);
        },
        displayField(table_name, field_name) {
            return this.sum_fields[table_name].labels[field_name]
        },
        getMarkerColor(table_name) {
            var marker = this.markerColors[0]
            this.selectedFlow.map((rec, index) => {
                if (rec.table_name == table_name) {
                    marker = this.markerColors[index]
                }
            })
            return marker
        },
        getDetailFlow(table_name) {
            this.selectedFlow.map((rec) => {
                if (rec.table_name == table_name) {
                    return rec;
                }
            })
        },
        drawMap() {

            const linePath = [];
            const coordinates = this.detailData.coordinates.split(",0");
            coordinates.forEach(element => {
                const el = element.split(",")
                el[0] = parseFloat(el[0])
                el[1] = parseFloat(el[1])
                if (!isNaN(el[0]) && !isNaN(el[1])) {
                    linePath.push({ lat: parseFloat(el[1]), lng: parseFloat(el[0]) })
                }
            });
            //this.map.panTo(linePath[0]);
            var bounds = new window.google.maps.LatLngBounds();
            const index_akhir = linePath.length - 1
            bounds.extend(new window.google.maps.LatLng(linePath[0].lat, linePath[0].lng));
            bounds.extend(new window.google.maps.LatLng(linePath[index_akhir].lat, linePath[index_akhir].lng));
            //bounds.extend(new google.maps.LatLng(-7.250445, 112.768845)); // Surabaya
            this.map.fitBounds(bounds);

            const polyline = new window.google.maps.Polyline({
                path: linePath,
                geodesic: true,
                strokeColor: "#FF0000",
                strokeOpacity: 1.0,
                strokeWeight: 2,
            });

            polyline.setMap(this.map);


        },
        drawMapData(payload) {
            this.mainData[payload.table_name].forEach(record => {
                if (record.coordinate) {
                    const el = record.coordinate.split(",")
                    el[0] = parseFloat(el[0])
                    el[1] = parseFloat(el[1])
                    if (!isNaN(el[0]) && !isNaN(el[1])) {

                        /*const marker = new window.google.maps.Marker({
                            position: { lat: el[0], lng: el[1] },
                            map: this.map,
                            icon: this.getMarkerColor(payload.table_name),
                            title: record[this.selectedFlow[payload.selectedFlowIndex].fields[0]],
                            label: {
                                text: "Hanya saat zoom dekat",
                                color: "#000",
                                fontSize: "12px",
                            }
                        });
                        
                        this.map.addListener("zoom_changed", () => {
                            
                            const zoom = this.map.getZoom();
                            marker.setVisible(zoom >= 12);
                            console.log("xoom",zoom)
                            
                        });*/
                        
                        const marker = new window.google.maps.Marker({
                            position: { lat: el[0], lng: el[1] },
                            map: this.map,
                            icon: this.getMarkerColor(payload.table_name),
                            title: record[this.selectedFlow[payload.selectedFlowIndex].fields[0]],
                        });

                        marker.addListener("click", () => {
                            const content = `
                                <div>
                                ${record[this.selectedFlow[payload.selectedFlowIndex].fields[0]] || ""}<br/>
                                ${record[this.selectedFlow[payload.selectedFlowIndex].fields[1]] || ""}
                                </div>
                            `;
                            this.infoWindow.setContent(content);
                            this.infoWindow.open(this.map, marker);
                            this.fetchDetailData({ flow_id: this.selectedFlow[payload.selectedFlowIndex].id, rec_id: record.id })
                        });

                        this.mapDataMarker.push(marker);
                    }

                }
            });
        },
        drawJalan() {

            /*
            JLS // ungu #673ab7
            JKS // hijau tua #009688
            JKP-4 // coklat #795548
            JLP // abu2 #9e9e9e
            */

            const warna_fungsi = {
                "JLS": '#673ab7',
                "JKS": "#009688",
                "JKP-4": "#795548",
                "JLP": "#9e9e9e"
            }

            const warna = {
                "BAIK": '#2dd55b',
                "SEDANG": "#cbd52d",
                "RUSAK RINGAN": "#ff00ffff",
                "RUSAK BERAT": "#d52d2d"
            }

            this.tableChildData.forEach(child => {
                const ruas = this.getSpesificJalan(child.no_ruas)

                if(!ruas.nama_ruas_jalan){
                    return;
                }

                const linePath = [];
                const coordinates = child.coordinates.split(",0");
                coordinates.forEach(element => {
                    const el = element.split(",")
                    el[0] = parseFloat(el[0])
                    el[1] = parseFloat(el[1])
                    if (!isNaN(el[0]) && !isNaN(el[1])) {
                        linePath.push({ lat: parseFloat(el[1]), lng: parseFloat(el[0]) })
                    }
                });

                var lineColor = warna[child.kondisi]
                if(this.showFungsiJalan){
                    lineColor = warna_fungsi[ruas.fungsi]
                }
                console.log(ruas.fungsi, warna_fungsi[ruas.fungsi])
                const polyline = new window.google.maps.Polyline({
                    path: linePath,
                    geodesic: true,
                    strokeColor: lineColor,
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    map: this.map,
                    zIndex: 3
                });

                //polyline.setMap(this.map);
                this.mapJalan.push(polyline)

                // 4. Tambahkan event klik ke polyline
                polyline.addListener("click", (event) => {
                    const content = ruas.nama_ruas_jalan + " <br> "  + child.no_ruas + " (" + ruas.fungsi + ") <br> Kondisi :" + child.kondisi
                    this.infoWindow.setContent(content);
                    this.infoWindow.setPosition(event.latLng); // Posisi popup di tempat klik
                    this.infoWindow.open(this.map);
                    this.fetchDetailData({ flow_id: 35, rec_id: child.rec_jj_kondisi_jalan_id })
                });

            });

            this.mainData['rec_jj_kondisi_jalan'].forEach(jalan => {
                if (jalan.coordinate) {
                    const el = jalan.coordinate.split(",")
                    el[0] = parseFloat(el[0])
                    el[1] = parseFloat(el[1])
                    if (!isNaN(el[0]) && !isNaN(el[1])) {
                        const marker = new window.google.maps.Marker({
                            position: { lat: el[1], lng: el[0] },
                            map: this.map,
                            title: jalan.nama_ruas_jalan,
                            icon : {
                                path : window.google.maps.SymbolPath.CIRCLE,
                                scale:0,
                            },
                            label: {
                                text: jalan.nama_ruas_jalan,
                                color: "#00c",
                                fontSize: "12px",
                            }
                        });
                        marker.setVisible(false);
                        
                        /*
                        this.map.addListener("zoom_changed", () => {
                            
                            const zoom = this.map.getZoom();
                            marker.setVisible(zoom >= 15);
                            
                        });
                        */
                        

                        this.mapLabelJalanMarker.push(marker);
                    }
                }
             });

        },
        drawDrainase() {

            this.mainData['rec_drainase_child'].forEach(child => {
                const linePath = [];
                const coordinates = child.coordinates.split(",0");
                coordinates.forEach(element => {
                    const el = element.split(",")
                    el[0] = parseFloat(el[0])
                    el[1] = parseFloat(el[1])
                    if (!isNaN(el[0]) && !isNaN(el[1])) {
                        linePath.push({ lat: parseFloat(el[1]), lng: parseFloat(el[0]) })
                    }
                });

                const DrainasePolyline = new window.google.maps.Polyline({
                    path: linePath,
                    geodesic: true,
                    strokeColor: '#fff',
                    strokeOpacity: 1.0,
                    strokeWeight: 2,
                    map: this.map,
                    zIndex: 2
                });

                //polyline.setMap(this.map);
                this.mapDrainase.push(DrainasePolyline)

                // 4. Tambahkan event klik ke polyline
                DrainasePolyline.addListener("click", (event) => {
                    const content = "Kode : " + child.kodews + " <br>" + child.nama
                    this.infoWindow.setContent(content);
                    this.infoWindow.setPosition(event.latLng); // Posisi popup di tempat klik
                    this.infoWindow.open(this.map);
                    this.fetchDetailData({ flow_id: 68, rec_id: child.id })
                });

            });

        },
        drawWilayah() {
            this.mapWilayah.forEach((p) => {
                p.setMap(null)
            });
            this.mapWilayah.splice(0)

            var bounds = new window.google.maps.LatLngBounds();
            this.selectedWilayah.forEach(child => {
                const linePath = [];
                const coordinates = child.coordinates.split(",0");
                coordinates.forEach(element => {
                    const el = element.split(",")
                    el[0] = parseFloat(el[0])
                    el[1] = parseFloat(el[1])
                    if (!isNaN(el[0]) && !isNaN(el[1])) {
                        linePath.push({ lat: el[1], lng: el[0] })
                        bounds.extend(new window.google.maps.LatLng(el[1], el[0]));
                    }
                });

                const polygon = new window.google.maps.Polygon({
                    paths: linePath,
                    strokeColor: this.kecamatan[child.kecamatan],
                    strokeOpacity: 0.8,
                    strokeWeight: 0.5,
                    fillColor: this.kecamatan[child.kecamatan],
                    fillOpacity: 0.3,
                    editable: false, // bisa diedit manual setelah terbentuk
                    map: this.map,
                    zIndex: 1,
                    clickable: false
                });
                this.mapWilayah.push(polygon)

            })
            this.map.fitBounds(bounds);
        },
        generatePolaRuangArea() {
            // Clear existing pola ruang area polygons
            this.mapPolaRuangArea.forEach((p) => {
                p.setMap(null)
            });
            this.mapPolaRuangArea.splice(0)

            // Generate area polygons for rec_taru_rencana_pola_ruang
            if (this.mainData['rec_taru_rencana_pola_ruang']) {
                this.mainData['rec_taru_rencana_pola_ruang'].forEach(record => {
                    if (record.coordinates && this.pola_ruang_line.indexOf(record.place_name)== -1) {
                        const objects = record.coordinates.split("|");
                        objects.forEach(polyCords => {

                            const linePath = [];
                            const coordinates = polyCords.split(" ");
                            coordinates.forEach(element => {
                                const el = element.split(",")
                                el[0] = parseFloat(el[0])
                                el[1] = parseFloat(el[1])
                                if (!isNaN(el[0]) && !isNaN(el[1])) {
                                    linePath.push({ lat: el[1], lng: el[0] })
                                }
                            });

                            if (linePath.length > 2) {
                                const polygon = new window.google.maps.Polygon({
                                    paths: linePath,
                                    strokeColor: this.rencana_pola_ruang_colors[record.place_name],
                                    strokeOpacity: 0.8,
                                    strokeWeight: 1,
                                    fillColor: this.rencana_pola_ruang_colors[record.place_name],
                                    fillOpacity: 0.8,
                                    editable: false,
                                    map: this.map,
                                    zIndex: 3
                                });

                                // Add click event listener
                                polygon.addListener("click", (event) => {
                                    const content = `
                                        <div>
                                            <strong>${record.place_name || "Pola Ruang"}</strong><br/>
                                            ${record.place_type || ""}<br/>
                                            ${record.notes || ""}
                                        </div>
                                    `;
                                    this.infoWindow.setContent(content);
                                    this.infoWindow.setPosition(event.latLng);
                                    this.infoWindow.open(this.map);
                                    // Fetch detail data if needed
                                    if (record.id) {
                                        this.fetchDetailData({ flow_id: 71, rec_id: record.id })
                                    }
                                });

                                this.mapPolaRuangArea.push(polygon)
                            }

                        })
                    }
                });
            }
        },
        generatePolaRuangLine() {
            // Clear existing pola ruang lines
            this.mapPolaRuangLine.forEach((line) => {
                line.setMap(null)
            });
            this.mapPolaRuangLine.splice(0)

            // Generate lines for rec_taru_rencana_pola_ruang
            if (this.mainData['rec_taru_rencana_pola_ruang']) {
                this.mainData['rec_taru_rencana_pola_ruang'].forEach(record => {
                    if (record.coordinates && this.pola_ruang_line.indexOf(record.place_name)!= -1) {
                        const objects = record.coordinates.split("|");
                        objects.forEach(polyCords => {
                            const linePath = [];
                            const coordinates = polyCords.split(" ");
                            coordinates.forEach(element => {
                                const el = element.split(",")
                                el[0] = parseFloat(el[0])
                                el[1] = parseFloat(el[1])
                                if (!isNaN(el[0]) && !isNaN(el[1])) {
                                    linePath.push({ lat: el[1], lng: el[0] })
                                }
                            });

                            if (linePath.length > 1) {
                                const polyline = new window.google.maps.Polyline({
                                    path: linePath,
                                    geodesic: true,
                                    strokeColor: this.rencana_pola_ruang_colors[record.place_name],
                                    strokeOpacity: 0.7,
                                    strokeWeight: 1,
                                    map: this.map,
                                    zIndex: 5
                                });

                                console.log("line")
                                // Add click event listener
                                polyline.addListener("click", (event) => {
                                    const content = `
                                        <div>
                                            <strong>${record.place_name || "Pola Ruang"}</strong><br/>
                                            ${record.place_type || ""}<br/>
                                            ${record.notes || ""}
                                        </div>
                                    `;
                                    this.infoWindow.setContent(content);
                                    this.infoWindow.setPosition(event.latLng);
                                    this.infoWindow.open(this.map);
                                    // Fetch detail data if needed
                                    if (record.id) {
                                        this.fetchDetailData({ flow_id: 71, rec_id: record.id })
                                    }
                                });

                                this.mapPolaRuangLine.push(polyline)
                            }

                        })
                    }
                });
            }
        },
        async fetchWilayah() {
            try {
                const params = {
                    limit: 1000,
                    table_name: "rec_wilayah",
                    fields: "kecamatan,desa,coordinates"
                }
                const response = await axios.get(`${this.baseUrl}/api/data`, {
                    params,
                    headers: this.apiHeaders
                })
                
                this.wilayah = response.data.data
                this.selectedWilayah = this.wilayah
                this.drawWilayah()
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data wilayah')
            }
        },
        async fetchData(payload) {
            try {
                var params = {
                    limit: 5000,
                    table_name: payload.table_name,
                    fields: payload.main_fields,
                    q: payload.q
                }
                const rec_need_coordinates = ['rec_drainase_child','rec_taru_rencana_pola_ruang']
                console.log(payload.table_name,rec_need_coordinates)
                if (rec_need_coordinates.indexOf(payload.table_name) !== -1 ) {
                    params.fields += ",coordinates"
                }
                if (payload.table_name == 'rec_jj_kondisi_jalan') {
                    params.fields += ",fungsi"
                }
                if (payload.kecamatan != '') {
                    params.kecamatan = payload.kecamatan
                }
                if (payload.uptd != '') {
                    params.uptd = payload.uptd
                }
                if (this.filter.dateRange && this.filter.dateRange.length === 2) {
                    params.date_start = this.filter.dateRange[0]
                    params.date_end = this.filter.dateRange[1]
                }
                
                const response = await axios.get(`${this.baseUrl}/api/data`, {
                    params,
                    headers: this.apiHeaders
                })
                
                this.mainData[payload.table_name] = response.data.data
                this.calculate_summary(payload.table_name)
                
                if (payload.table_name == 'rec_drainase_child') {
                    this.drawDrainase()
                } else if (payload.table_name == 'rec_jj_kondisi_jalan') {
                    //draw jalan
                } else if (payload.table_name == 'rec_taru_rencana_pola_ruang') {
                    this.generatePolaRuangArea()
                    this.generatePolaRuangLine()
                } else {
                    this.drawMapData({ table_name: payload.table_name, selectedFlowIndex: payload.selectedFlowIndex })
                }
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data')
            }
        },
        calculate_summary(table_name) {
            this.sum_value = {}
            if (!this.sum_fields[table_name]) {
                return
            }

            this.mainData[table_name].forEach(data => {
                this.sum_fields[table_name].sum.forEach(field => {
                    const val = parseFloat(data[field])
                    if (!isNaN(val)) {
                        if (!this.sum_value[table_name]) {
                            this.sum_value[table_name] = { sum: {} }
                        }
                        if (!this.sum_value[table_name].sum[field]) {
                            this.sum_value[table_name].sum[field] = 0
                        }
                        this.sum_value[table_name].sum[field] += val
                    }

                })

            })
            //console.log("this.sum_value", this.sum_value)

        },
        async fetchChildData(payload) {
            try {
                var params = {
                    limit: 15000,
                    table_name: payload.table_name,
                    fields: "no_ruas,rec_jj_kondisi_jalan_id,coordinates,kondisi",
                }
                if (payload.kecamatan != '') {
                    params.kecamatan = payload.kecamatan
                }
                if (payload.uptd != '') {
                    params.uptd = payload.uptd
                }
                if (this.filter.dateRange && this.filter.dateRange.length === 2) {
                    params.date_start = this.filter.dateRange[0]
                    params.date_end = this.filter.dateRange[1]
                }

                const response = await axios.get(`${this.baseUrl}/api/data`, {
                    params,
                    headers: this.apiHeaders
                })
                
                this.tableChildData = response.data.data
                this.drawJalan()
            } catch (error) {
                this.handleError(error, 'Gagal mengambil data detail jalan')
            }
        },
        async fetchDetailData(row) { //{flow_id:35,rec_id:5}
            try {
                const response = await axios.get(`${this.baseUrl}/api/data/${row.flow_id}/${row.rec_id}`, {
                    headers: this.apiHeaders
                })
                
                this.detailData = response.data.data
                this.getPageField(response.data.flow.id)
                this.fetchDataCatatan({ rec_id: row.rec_id, data_name: response.data.flow.table_name })
                this.detailFlowSelected = response.data.flow
                this.drawerDetailInformasi = true
            } catch (error) {
                this.handleError(error, 'Gagal mengambil detail data')
            }
        },
        async fetchDataCatatan(row) {
            try {
                const response = await axios.get(`${this.baseUrl}/api/notes/${row.rec_id}?data_name=${row.data_name}`, {
                    headers: this.apiHeaders
                })
                
                this.detailCatatan = response.data.data
            } catch (error) {
                this.handleError(error, 'Gagal mengambil catatan')
            }
        },
        async getPageField(flow_id) {
            try {
                const response = await axios.get(`${this.baseUrl}/api/page/default/${flow_id}`, {
                    headers: this.apiHeaders
                })
                
                this.listFields = response.data.fields
            } catch (error) {
                this.handleError(error, 'Gagal mengambil konfigurasi field')
            }
        },
        
        formatDateTime(value) {
            if (!value) return ''
            const date = new Date(value)
            return new Intl.DateTimeFormat('id-ID', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(date)
        },
        
        handleError(error, defaultMessage = '') {
            const message = error.response?.data?.message || defaultMessage || 'Terjadi kesalahan'
            this.$message({
                message,
                type: 'error'
            })
            console.error('Error:', error)
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.map-view-container {
    width: 100%;
    height: calc(100vh - 100px); /* Subtract top menu height */
    overflow: hidden;
    background-color: #f5f7fa;
}

.main-container {
    height: 100%;
}

.map-sidebar {
    background-color: #ffffff;
    border-right: 1px solid #EBEEF5;
    height: calc(100vh - 100px); /* Subtract top menu height */
    box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
    display: flex;
    flex-direction: column;
    height: 100%;
}

.sidebar-header {
    padding: 20px;
    background-color: #fafafa;
    border-bottom: 1px solid #EBEEF5;
    flex-shrink: 0;
}

.sidebar-header h3 {
    margin: 0;
    color: #303133;
    font-size: 18px;
}

.sidebar-header p {
    margin: 5px 0 0 0;
    color: #909399;
    font-size: 14px;
}

.sidebar-tabs {
    padding: 15px;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.sidebar-tabs .el-tabs__content {
    flex: 1;
}

.filter-form {
    padding: 10px 0;
    overflow: auto;
}

.filter-form .el-form-item {
    margin-bottom: 15px;
}

.road-options {
    margin: 20px 0;
}

.road-options .el-checkbox {
    display: block;
    margin-bottom: 10px;
}

.summary-section {
    margin-top: 20px;
    overflow: auto;
    padding-right: 5px;
}

.summary-section::-webkit-scrollbar {
    width: 6px;
}

.summary-section::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
}

.summary-section::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.summary-section::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.summary-item {
    margin-bottom: 15px;
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 8px;
}

.summary-header {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.summary-descriptions {
    background-color: white;
}

.map-container {
    padding: 0;
    position: relative;
}

.table-row-content {
    display: flex;
    align-items: flex-start;
    padding: 8px 0;
}

.icon-column {
    width: 30px;
    min-width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 2px;
}

.data-content {
    flex: 1;
    line-height: 1.4;
    padding-left: 5px;
}

.primary-text {
    font-weight: 600;
    color: #303133;
    font-size: 14px;
    display: block;
    margin-bottom: 4px;
}

.secondary-text {
    color: #606266;
    font-size: 13px;
    display: block;
    margin-bottom: 2px;
}

.detail-descriptions {
    margin-bottom: 20px;
}

.notes-descriptions {
    max-height: 300px;
    overflow-y: auto;
}

/* Drawer styles */
.el-drawer__header {
    padding: 20px;
    border-bottom: 1px solid #EBEEF5;
}

.el-drawer__body {
    padding: 20px;
}

/* Tab styles */
.el-tabs__header {
    margin-bottom: 15px;
}

.el-tabs__nav-wrap::after {
    height: 1px;
}

/* Table styles for better readability */
.el-table .el-table__row {
    cursor: pointer;
}

.el-table .el-table__row:hover {
    background-color: #f5f7fa;
}

/* Button styles */
.el-button {
    font-weight: 500;
}

/* Form styles for better spacing */
.el-select {
    width: 100%;
}

.el-input {
    width: 100%;
}

/* Alert styles */
.el-alert {
    border-radius: 6px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .map-sidebar {
        width: 100% !important;
        height: 50vh;
    }
    
    .map-container {
        height: 50vh;
    }
    
    .el-container {
        flex-direction: column !important;
    }
}
</style>